module.exports = __webpack_public_path__ + "img/du.46b207c0.png";